import { gql } from "graphql-request"

const ripple = {
    name: 'ripple',
    title: 'Ripple XRP Ledger',
    currency: 'XRP',
    check: true,
    regexp: '([\\W]|^)(r[\\dA-Za-z]{32,33})([\\W]|$)',
    noregxp: [
        '([\\W]|^)(bnb[0-9a-z]{2})([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{2)([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{2)([\\W]|$)',
        '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
    ],
    query: gql`query ($address: String!) {
        ripple(network: ripple) {
            address(address: {is: $address}) {
                balance: balance
                balance_usd: balance(in: USD)
            }
            ins: transfers(receiver: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyIn: transfers(receiver: {is: $address}) {
                count
                currency: currencyTo {
                    symbol
                    address
                    tokenId
                }
            }
            outs: transfers(sender: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyOut: transfers(sender: {is: $address}) {
                count
                currency: currencyFrom {
                    symbol
                    address
                    tokenId
                }
            }
        }
    }`,
    checkAddress: 'r4AZpDKVoBxVcYUJCWMcqZzyWsHTteC4ZE',
}
export { ripple }
